import React from 'react';
import {
  Button,
  Modal,
  ModalProps,
  Row,
  Table,
} from 'antd';
import { message } from 'components/common';
import { COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION } from 'constants/config';
import { getProductUomList } from 'services/product'
import { PoRecvActionType as PRAction } from './context';

type Props = ModalProps & {
  dispatch: Function;
  onSelectUom: Function;
  refInfo: StringKAnyVPair;
  state: StringKAnyVPair;
};

let lastSku = '';
let lastUomList: StringKAnyVPair[] = [];

const UomSelector = (props: Props) => {
  const { useState } = React;
  const [inited, setInited] = useState(false);
  const [uomList, setUomlist] = useState<StringKAnyVPair[]>([]);

  const columns = [
    {
      title: 'Case Pack',
      dataIndex: 'uom',
    },
    {
      title: 'Pack Name',
      dataIndex: 'name',
    },
    {
      title: 'Rate',
      dataIndex: 'uomRate',
      width: 80,
    },
  ];

  const dialogFooter = () => {
    return (
      <Row justify="end">
        <Button
          onClick={onCancel}
          size="large"
        >
          Cancel
        </Button>
      </Row>
    );
  };

  // eslint-disable-next-line
  const loadUomList = async () => {
    const { dispatch } = props;

    dispatch({ type: PRAction.SetLockScreen, params: true }); 
    try {
      const res = await getProductUomList(props.refInfo.sku);

      if (res && typeof res === 'object' && res.isSuccess) {
        //console.log(res.data, '<--');
        setUomlist(res.data)
        lastSku = props.refInfo.sku;
        lastUomList = [ ...res.data ];
      }
    } catch(e) {
    } finally {
      dispatch({ type: PRAction.SetLockScreen, params: false }); 
    }
  };

  const onCancel = (evt: any) => {
    if (props.onCancel) props.onCancel(evt);
  };

  const onSelectUom = (uomInfo: StringKAnyVPair) => {
    const { dispatch } = props;
    const keys = ['uom', 'uomRate'];
    const uom: StringKAnyVPair = {};

    //console.log('uom', uomInfo, uom);
    for (const k of keys) if (uomInfo[k]) uom[k] = uomInfo[k];
    dispatch({ type: PRAction.SetUomInfo, params: uom });
    props.onSelectUom(uom);
    onCancel(undefined);
  };

  const uomRowProps = (row: StringKAnyVPair) => {
    return {
      onClick: () => onSelectUom(row),
    };
  };

  React.useEffect(() => {
    if (!inited) {
      if (lastSku === props.refInfo.sku && lastUomList.length > 0) {
        setUomlist(lastUomList);
      } else {
        loadUomList();
      }

      setInited(true);
    }
  }, [inited, loadUomList, props]);

  return (<>
    <Modal
      { ...props }
      footer={dialogFooter()}
    >
      <Table
        columns={columns}
        dataSource={uomList}
        onRow={uomRowProps}
        pagination={false}
        rowKey="productUomNum"
        scroll={{y: 440}}
        size="middle"
      />
    </Modal>
  </>);
};

export default UomSelector;

export const checkoutUomBySkuAndCode = async (
  sku: string,
  code: string,
  state: StringKAnyVPair,
  dispatch: Function,
) => {
  dispatch({ type: PRAction.SetLockScreen, params: true }); 

  try {
    const res = await getProductUomList(sku);

    if (res && typeof res === 'object' && res.isSuccess) {
      if (Array.isArray(res.data)) {
        const u = res.data.find((e: any) => e.uom === code);

        if (u) {
          const keys = ['uom', 'uomRate'];
          const uom: StringKAnyVPair = {};

          for (const k of keys) if (u[k]) uom[k] = u[k];
          //console.log('uom', uom);
          dispatch({ type: PRAction.SetUomInfo, params: uom });
        }
      }
    }
  } catch(e) {
    message.error({
      content: 'Loaded UOM list error',
      duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
    });
  } finally {
    dispatch({ type: PRAction.SetLockScreen, params: false }); 
  }
};
